<template>
  <div class="load">
    <div class="content">
      <div class="">
        <img src="./../../assets/school/load2.png" alt="" />
        <img class="pig" src="./../../assets/school/load3.png" alt="" />
        <img
          src="./../../assets/school/load4.png"
          alt=""
          class="btn"
          @click="toApp()"
        />
      </div>
    </div>
    <Share :maskShow="maskShow" @closeMaskShow="closeMaskShow"></Share>
  </div>
</template>

<script>
import Share from "./components/share.vue";
export default {
  data() {
    return {
      shareCode: "",
      isWeixin: false,
      isQQ: false,
      maskShow: true,
    };
  },
  components: { Share },
  created() {
    let ua = navigator.userAgent.toLowerCase();
    this.isWeixin = ua.indexOf("micromessenger") !== -1; // 微信内
    if (ua.indexOf("qq") > -1 && ua.indexOf("mqqbrowser") < 0 && this.isiOS) {
      //qq内置浏览器
      this.isQQ = true;
    }
    if (this.isWeixin || this.isQQ) {
      this.maskShow = true;
    } else {
      this.maskShow = false;
    }
  },
  methods: {
    toApp() {
      if (this.isWeixin || this.isQQ) {
        this.maskShow = true;
      } else {
        window.location.href = "xblife://";
        setTimeout(function () {
          let hidden =
            window.document.hidden ||
            window.document.mozHidden ||
            window.document.msHidden ||
            window.document.webkitHidden;
          if (typeof hidden == "undefined" || hidden == false) {
            window.location.href =
              "http://a.app.qq.com/o/simple.jsp?pkgname=com.shallbuy.xiaoba.life";
          }
        }, 2000);
      }
    },
    // 关闭遮罩层
    closeMaskShow() {
      this.maskShow = false;
    },
  },
};
</script>

<style lang="less">
.load {
  height: 100%;
  .content {
    position: relative;
    height: 100%;
    background: url("./../../assets/school/load1.png") no-repeat center;
    background-size: cover;
    display: flex;
    align-items: center;
    div {
      position: absolute;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 81%;
      }
      .pig {
        width: 67px;
        height: 95px;
        align-self: flex-end;
        margin-right: 34px;
        margin-top: -100px;
      }
      .btn {
        width: 100%;
        margin-top: -26px;
      }
    }
  }
}
</style>
